/**
 * Local storage key holding the language a visitor picked before they have a
 * profile. It is local rather than session storage because the choice has to
 * outlive the tab: account creation can return in a new one, and business
 * enrollment, which keeps its own i18next instance, reads it on startup.
 * Once a profile loads, its language decides and the shell removes the entry.
 */
export const SIGNED_OUT_LOCALE_STORAGE_KEY = 'signedOutLocale';
